// extracted by mini-css-extract-plugin
export default {"stack":"ErrorBoundary_stack__f32Ep","eventId":"ErrorBoundary_eventId__G-bOj"};